
<template>
    <div class="page-layout blank contacts-manage mb-10 mt-0">
        <div class="breadcrumbactive">
            <div >
                <span class="pointer" @click="goToTemplateList">Template List</span>
                <div v-if="$route.path.startsWith('/dynamictemplate/create')">Create New</div>
                <div v-if="$route.path.startsWith('/dynamictemplate/edit')">Edit</div>
            </div>
        </div>
        <div class="template-list-main-container">
            <div class="template-list-main-container-inner">
                <div class="template-list-header">
                    <span class="fs-14 text-white">Template Creation </span>
                </div>
                <div v-if="ajax_call_in_progress" class="position-relative">
                    <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center position-relative"/>
                </div>
                <div v-else>
                    <div class="template-list-inner-content">
                        <div class="row">
                            <div class="col-lg-4 col-md-6 col-sm-12">
                                <div class="form-group contactGroup pt-0">
                                    <div class="w-100" style="position: relative;">
                                        <label class="inputLabel fs-14 fw-600 text-black">Template Name 
                                            <span class="text-danger">*</span>
                                            <el-tooltip class="item pull-right" effect="dark" content="Non-removable fields" placement="bottom">
                                                <i class="icon icon-information-outline pointer text-new-blue fs-16"></i>
                                            </el-tooltip>
                                        </label>
                                        <input class="inputFieldNew inputFieldNew-padding" v-validate="'required'" name="template_name" v-model="template_name" type="text" autocomplete="off" placeholder="Enter Template Name" />
                                        <span class="inputBorder"></span>
                                        <span class="invalid-feedback-form text-danger mt-0 position-absolute" v-show="errors.has('template_name')">{{errors.first('template_name')}}</span>
                                        <div class="text-right fs-14">{{100 - template_name.length}}/100</div>
                                    </div> 
                                </div>
                            </div>
                        </div>
                        <div>
                            <div v-for="(que_data, all_questions_index) in all_questions" :key="all_questions_index+'dd'" class="d-flex mt-3">
                                <div class="template-list-question-box w-100">
                                    <div class="row flex-column-reverse flex-lg-row">
                                        <div class="col-lg-8 col-md-12 col-sm-12">
                                            <div class="w-100" style="position: relative;">
                                                <input class="inputFieldNew inputFieldNew-padding" maxlength="150" v-validate="'required'" :name="'question'+all_questions_index" data-vv-as="Question" v-model="que_data.name" type="text" autocomplete="off" placeholder="Enter Question" />
                                                <span class="inputBorder"></span>
                                            </div> 
                                            <span class="invalid-feedback-form text-danger" v-show="errors.has('question'+all_questions_index)">{{errors.first('question'+all_questions_index)}}</span>
                                        </div>
                                        <div class="col-lg-4 col-md-6 col-sm-12">
                                            <div class="form-group contactGroup pt-2">
                                                <div class="">
                                                    <multiselect
                                                        class="diginew-multiselect diginew-multiselect-dropdown"
                                                        v-model="que_data.type"
                                                        :options="type_options"
                                                        :searchable="true"
                                                        :name="'type'+all_questions_index"
                                                        :close-on-select="true"
                                                        v-validate="'required'"
                                                        :show-labels="false"
                                                        data-vv-as="Type"
                                                        placeholder="Select Type"
                                                        internal-search="true"
                                                    >
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                                        </template>
                                                    </multiselect>
                                                </div>
                                                <span class="invalid-feedback-form text-danger" v-show="errors.has('type'+all_questions_index)">{{errors.first('type'+all_questions_index)}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row align-items-end">
                                        <div class="col-lg-8 col-md-8 col-sm-12">
                                            <!-- Radio Button -->
                                            <div v-if="que_data.type == 'Radio Button' || que_data.type == 'radio_button'" class="d-flex form-check form-check-inline">
                                                <div v-for="(radio_btn, radio_btn_index) in que_data.possible_values" :key="radio_btn_index">
                                                    <label class="form-check-label position-relative mt-3">
                                                        <input class="form-check-input" :disabled="true" style="top: 5px;left: -5px;width: 20px;height: 20px;" type="radio"
                                                            value="option 1">
                                                        <span class="radio-icon" style="width: 20px;height: 20px;"></span>
                                                        <input type="text" maxlength="150" v-model="que_data.possible_values[radio_btn_index]" v-validate="'required'" data-vv-as="Option" :name="'radio_options'+all_questions_index+''+radio_btn_index" :placeholder="'Option '+(radio_btn_index+1)" class="input-border-bottom pb-0" style="width: 200px !important; border-bottom: solid 2px #0d84f2 !important;" />
                                                        <i :class="{'icon-delete-opacity-show':radio_btn_index>1}" class="icon icon-right fs-18 icon-delete text-secondary icon-delete-opacity-hide pointer" @click="deleteOptions('radio_btn_option', all_questions_index, radio_btn_index)"></i>
                                                        <i v-if="(que_data.possible_values.length - 1 == radio_btn_index) && (que_data.possible_values.length < 10)" class="icon icon-right fs-18 icon-plus-circle text-success pointer" @click="addOptions('radio_btn_option', all_questions_index, radio_btn_index)"></i>
                                                    </label>
                                                    <span class="invalid-feedback-form text-danger" v-show="errors.has('radio_options'+all_questions_index+''+radio_btn_index)">{{errors.first('radio_options'+all_questions_index+''+radio_btn_index)}}</span>
                                                </div>
                                            </div>
                                            <div class="text-left text-danger mb-3 text-capitalize mt-5 w-100" v-if="check_duplicate_radio && reached_validator">Options Must be Unique</div>
                                            <!-- Checkbox -->
                                            <div v-else-if="que_data.type == 'Check Box' || que_data.type == 'check_box'" class="d-flex align-items-center flex-wrap">
                                                <div v-for="(checkbox, checkbox_index) in que_data.possible_values" :key="checkbox_index">
                                                    <div class="d-flex align-items-end mt-3">
                                                        <el-checkbox :disabled="true" class="mb-0 mr-2"></el-checkbox>
                                                        <input type="text" v-validate="'required'" maxlength="150" data-vv-as="Option" :name="'checkbox_options'+all_questions_index+''+checkbox_index" :placeholder="'Option '+(checkbox_index+1)" v-model="que_data.possible_values[checkbox_index]" class="input-border-bottom pb-0" style="width: 200px !important;border-bottom: solid 2px #0d84f2 !important;" />
                                                        <i :class="{'icon-delete-opacity-show':checkbox_index>1}" class="icon icon-right fs-18 icon-delete text-secondary icon-delete-opacity-hide pointer" @click="deleteOptions('checkbox_option', all_questions_index, checkbox_index)"></i>
                                                        <i v-if="(que_data.possible_values.length - 1 == checkbox_index) && (que_data.possible_values.length < 10)" class="icon icon-right fs-18 icon-plus-circle text-success pointer" @click="addOptions('checkbox_option', all_questions_index, checkbox_index)"></i>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger" v-show="errors.has('checkbox_options'+all_questions_index+''+checkbox_index)">{{errors.first('checkbox_options'+all_questions_index+''+checkbox_index)}}</span>
                                                </div>
                                            </div>
                                            <div class="text-left text-danger mb-3 text-capitalize mt-5 w-100" v-if="check_duplicate_check && reached_validator">Options Must be Unique</div>
                                            <!-- Dropdown -->
                                            <div v-else-if="que_data.type == 'Drop Down' || que_data.type == 'drop_down'" class="d-flex align-items-center flex-wrap">
                                                <div v-for="(dropdown, dropdown_index) in que_data.possible_values" :key="dropdown_index" class="mt-3">
                                                    <div class="d-flex align-items-end">
                                                        <input type="text" v-validate="'required'" maxlength="150" data-vv-as="Option" :name="'dropdown_options'+all_questions_index+''+dropdown_index" :placeholder="'Option '+(dropdown_index+1)" v-model="que_data.possible_values[dropdown_index]" class="input-border-bottom pb-0" style="width: 228px !important;border-bottom: solid 2px #0d84f2 !important;" />
                                                        <i :class="{'icon-delete-opacity-show':dropdown_index>1}" class="icon icon-right fs-18 icon-delete text-secondary icon-delete-opacity-hide pointer" @click="deleteOptions('dropdown_option', all_questions_index, dropdown_index)"></i>
                                                        <i v-if="(que_data.possible_values.length - 1 == dropdown_index) && (que_data.possible_values.length < 10)" class="icon icon-right fs-18 icon-plus-circle text-success pointer" @click="addOptions('dropdown_option', all_questions_index, dropdown_index)"></i>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger" v-show="errors.has('dropdown_options'+all_questions_index+''+dropdown_index)">{{errors.first('dropdown_options'+all_questions_index+''+dropdown_index)}}</span>
                                                </div>
                                            </div>
                                            <div class="text-left text-danger mb-3 text-capitalize mt-5 w-100" v-if="check_duplicate_drop && reached_validator">Options Must be Unique</div>
                                            <!-- Short Answer -->
                                            <div v-else-if="que_data.type == 'Short Answer' || que_data.type == 'short_answer'" class="mt-3">
                                                <input type="text" readonly :name="'short_answer'+all_questions_index" placeholder="Short Answer" style="border-bottom: solid 2px #0d84f2 !important;" class="input-border-bottom pb-0" />
                                            </div>
                                            <!-- Long Answer -->
                                            <div v-else-if="que_data.type == 'Long Answer' || que_data.type == 'long_answer'" class="mt-3">
                                                <input type="text" readonly :name="'long_answer'+all_questions_index" placeholder="Long Answer" style="border-bottom: solid 2px #0d84f2 !important;" class="input-border-bottom pb-0" />
                                                <input type="text" readonly :name="'long_answer'+all_questions_index" placeholder="" style="border-bottom: solid 2px #0d84f2 !important;" class="input-border-bottom pb-0 mt-3" />
                                            </div>
                                            <!-- Date --> 
                                            <div v-else-if="que_data.type == 'Date' || que_data.type == 'date'" class="mt-3">
                                                <date-picker name="date"
                                                    class="inputFieldNew-border-bottom date-picker-disabled" placeholder="MM/DD/YYYY"
                                                    format="MM/DD/YYYY" type="date" lang="en"
                                                    style="border:none !important" :disabled="true">
                                                </date-picker>
                                            </div>
                                            <!-- Time --> 
                                            <div v-else-if="que_data.type == 'Time' || que_data.type == 'time'" class="mt-3">
                                                <date-picker
                                                    class="new-time-picker new-time-picker-icon input-field-underline date-picker-disabled date-picker-clock-icon mt-3"
                                                    placeholder="--:--" value-type="format" style="padding-right: 2px !important;" lang="en"
                                                    type="time" format="HH/MM" :disabled="true">
                                                </date-picker>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12 mt-2">
                                            <div class="d-flex align-items-center justify-content-end">
                                                <span>
                                                    Required
                                                </span>
                                                <span class="ml-2">
                                                    <el-switch v-model="que_data.required">
                                                    </el-switch>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="template-list-question-box-options" style="height: max-content;">
                                    <div class="d-flex flex-column align-items-center">
                                        <el-dropdown trigger="click">
                                            <span class="el-dropdown-link">
                                                <i class="icon icon-arrow-all pointer" style="color: #0d84f2;"></i>
                                            </span>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item>
                                                    <span v-if="all_questions_index > 0" class="d-flex align-items-center">
                                                        <i class="icon icon-arrow-up" style="color: #303031 !important;font-size: 20px !important;"></i>
                                                        <span @click="moveEntry(all_questions_index, 'move_up')" class="fs-14">Move Above</span>
                                                    </span>
                                                </el-dropdown-item>
                                                <el-dropdown-item>
                                                    <span class="d-flex align-items-center">
                                                        <i class="icon icon-arrow-down" style="color: #303031 !important; font-size: 20px !important;"></i>
                                                        <span class="fs-14" @click="moveEntry(all_questions_index, 'move_down')">Move Down</span>
                                                    </span>
                                                </el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                        <img class="mt-2 pointer" src="/static/images/icon-awesome-copy.svg" @click="copyQuestion(all_questions_index)" width="20" height="20" alt="copy" />
                                        <i v-if="all_questions_index == 0" class="icon icon-delete mt-2" style="color: #707070; cursor: not-allowed;"></i>
                                        <i v-else class="icon icon-delete mt-2 pointer" @click="deleteQuestion(all_questions_index)" style="color: #0d84f2;"></i>
                                        <i v-if="all_questions.length < 10" class="icon icon-plus-circle mt-2 pointer" @click="addNewQuestion()" style="color: #0d84f2;"></i>
                                        <i v-else class="icon icon-plus-circle mt-2 pointer" style="color: #707070; cursor: not-allowed;"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-left text-danger mb-3 text-capitalize mt-5 w-100" v-if="check_duplicate_question && reached_validator">*There are question/questions that repeats more than one time</div>
                    </div>
                    <div class="d-flex align-items-center justify-content-center my-4">
                        <button type="button" class="btn btn-danger-new" @click="goToListView" >Cancel</button>
                        <button type="button" class="btn btn-success ml-4 text-white" :disabled="is_api_calling" @click="createSuccess" >Save</button>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import { SweetModal } from 'sweet-modal-vue';
import dynamic_template from '../../mixins/dynamic_template.js'
export default {
    mixins: [dynamic_template],
    components: {
        SweetModal
    },
    data() {
        return {
            success_msg:'',
            warning_msg:'',
            template_name: "",
            ajax_call_in_progress: false,
            limit: 10,
            skip: 0,
            isVisible: false,
            type_options: ['Radio Button', 'Check Box', 'Short Answer', 'Long Answer', 'Drop Down', 'Date', 'Time', 'Tag'],
            search_key: '',
            dropdown_loading: false,
            scrollable: false,
            is_api_calling: false,
            all_questions: [{
                required: false,
                type: 'Radio Button',
                name: '',
                possible_values: ['', ''],
            }],
            check_duplicate_radio: false,
            check_duplicate_check: false,
            check_duplicate_drop: false,
            check_duplicate_question: false,
            reached_validator: false,
        }
    },
    methods: {
        goToTemplateList() {
            this.$router.push('/settings?type=templatesnew')
        },
        deleteOptions(type, parent_index, index) {
            this.all_questions[parent_index].possible_values.splice(index, 1)
        },
        addOptions(type, parent_index, index) {
            this.all_questions[parent_index].possible_values.push('')
        },
        addNewQuestion() {
            this.all_questions.push(
                {
                    required: false,
                    type: 'Radio Button',
                    name: '',
                    possible_values: ['', ''],
                }
            );
        },
        deleteQuestion(index) {
            this.all_questions.splice(index, 1)
        },
        copyQuestion(index) {
            this.all_questions.splice(index, 0, JSON.parse(JSON.stringify(this.all_questions[index])))
        },
        moveEntry(index, type) {
            switch (type) {
                case 'move_up':
                    let element_up = this.all_questions[index];
                    this.all_questions.splice(index, 1);
                    this.all_questions.splice(index-1, 0, element_up);
                    break;
                case 'move_down':
                    let element_down = this.all_questions[index];
                    this.all_questions.splice(index, 1);
                    this.all_questions.splice(index+1, 0, element_down);
                    break;
            }
        },
        goToListView() {
            this.goToTemplateList();
        },
        async createSuccess() {
            localStorage.setItem('dynamic_template_data', JSON.stringify(this.create_data));
            let filtered_data = JSON.parse(localStorage.getItem('dynamic_template_data'));
            // let filtered_data = this.create_data
            let questions_list = []
            filtered_data.fields.forEach((data, index) => {
                let textFormat = data.name.toLowerCase().replace(/ /g,'')
                questions_list.push(textFormat)
            })
            this.check_duplicate_question = questions_list.some((val, i) => questions_list.indexOf(val) !== i); 
            filtered_data.fields.forEach((data, index) => {
                switch (data.type) {
                    case 'Radio Button' || 'radio_button':
                        data.type = 'radio_button';
                        this.check_duplicate_radio = filtered_data.fields[index].possible_values.some((val, i) => filtered_data.fields[index].possible_values.indexOf(val) !== i);
                        break;
                    case 'Check Box' || 'check_box':
                        data.type = 'check_box';
                        this.check_duplicate_check = filtered_data.fields[index].possible_values.some((val, i) => filtered_data.fields[index].possible_values.indexOf(val) !== i);
                        break;
                    case 'Drop Down' || 'drop_down':
                        data.type = 'drop_down';
                        this.check_duplicate_drop = filtered_data.fields[index].possible_values.some((val, i) => filtered_data.fields[index].possible_values.indexOf(val) !== i);
                        break;
                    case 'Short Answer' || 'short_answer':
                        data.type = 'short_answer';
                        delete filtered_data.fields[index].possible_values;
                        break;
                    case 'Long Answer' || 'long_answer':
                        data.type = 'long_answer';
                        delete filtered_data.fields[index].possible_values;
                        break;
                    case 'Date' || 'date':
                        data.type = 'date';
                        delete filtered_data.fields[index].possible_values;
                        break;
                    case 'Time' || 'time':
                        data.type = 'time';
                        delete filtered_data.fields[index].possible_values;
                        break;
                    case 'Tag' || 'tag':
                        data.type = 'tag';
                        delete filtered_data.fields[index].possible_values;
                        break;
                }
            })
            this.$validator.validateAll().then(async result => {
                if (result) {
                    this.reached_validator = true
                    if(this.$route.path.startsWith('/dynamictemplate/edit') && this.check_duplicate_radio == false && this.check_duplicate_check == false && this.check_duplicate_drop == false && this.check_duplicate_question == false) {
                        filtered_data.dynamic_template_id = this.$route.params.id;
                        this.saveDataEdit(filtered_data);
                    } else if(this.check_duplicate_radio == false && this.check_duplicate_check == false && this.check_duplicate_drop == false && this.check_duplicate_question == false) {
                        this.saveDataCreate(filtered_data);
                    }
                } else {
                    
                }
            });
        },
        async saveDataCreate(data) {
            this.is_api_calling = true;
            try {
                let params = data;
                let response = await this.createDynamicTemplate(params);
                this.success_msg = response.response.success_message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.goToTemplateList();
                }, 3000);
            }
            catch(err) {
                this.warning_msg = err;
                this.$refs.warning_modal.open();
                this.is_api_calling = false;
            }
        },
        async saveDataEdit(data) {
            this.is_api_calling = true;
            try {
                let params = data;
                let response = await this.editDynamicTemplate(params);
                this.success_msg = response.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.goToTemplateList();
                }, 3000);
            }
            catch(err) {
                this.warning_msg = err;
                this.$refs.warning_modal.open();
                this.is_api_calling = false;
            }
        },
        async getTemplateDataById(id) {
            this.ajax_call_in_progress = true;
            try {
                let param = {
                    dynamic_template_id: id
                };
                let response = await this.getDynamicTemplate(param);
                this.all_questions = response.response.fields;
                this.template_name = response.response.name;
                this.ajax_call_in_progress = false;
                this.all_questions.forEach((data, index) => {
                switch (data.type) {
                    case 'radio_button':
                        data.type = 'Radio Button';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'check_box':
                        data.type = 'Checkbox';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'drop_down':
                        data.type = 'Drop Down Selection';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'short_answer':
                        data.type = 'Short Answer Input Field';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'long_answer':
                        data.type = 'Long Answer Input Field';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'date':
                        data.type = 'Date';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'time':
                        data.type = 'Time';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                    case 'tag':
                        data.type = 'Tag';
                        if(data.possible_values) {
                        } else {
                            data.possible_values = ['', '']
                        }
                        break;
                }
            })
            }
            catch(err) {
                this.warning_msg = err;
                this.$refs.warning_modal.open();
                this.is_api_calling = false;
            }
        }
    },
    mounted() {
        if(this.$route.path.startsWith('/dynamictemplate/edit')) {
            this.getTemplateDataById(this.$route.params.id);
        }
    },
    computed: {
        create_data() {
            return {
                name: this.template_name,
                fields: this.all_questions
            }
        }
    },
    created(){
        const dict = {
            custom: {
                template_name:{
                    required:() => "Template name is Required",
                },
            }
        }
        this.$validator.localize("en", dict); 
    }
}
</script>
<style scoped>
    .template-list-main-container {
        padding: 13.5px;
        border-radius: 6px;
        background-color: #fff;
    }
    .template-list-main-container-inner {
        padding: 16.5px 0 12.3px;
        border-radius: 6px;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.16);
        background-color: #fff;
    }
    .template-list-header {
        margin: 0 0 14.2px;
        padding: 9.7px 35.5px;
        background-color: #005dae;
    }
    .template-list-inner-content {
        padding: 9.7px 35.5px;
    }
    .template-list-inner-content .row {
        margin-left: -15px !important;
        margin-right: -15px !important;
    }
    .template-list-question-box {
        padding: 12px 18.5px 12px 21.5px;
        box-shadow: 0 0 2px 0 #939393;
        border-radius: 5px;
        /* border: solid 0.3px #6c6d6f; */
        background-color: #fff;
    }
    .input-border-bottom {
        border: 0 !important;
        padding: 5px 8px;
        padding-left: 0;
        width: 100% !important;
        border-bottom: solid 1px #707070 !important;
    }
    .icon-delete-opacity-hide {
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
    }
    .icon-delete-opacity-show {
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
    }
    .template-list-question-box-options {
        padding: 5.6px 4px 5.5px 1.8px;
        border-radius: 1px;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.33);
        background-color: #fff;
    }
</style>